import Naluri from '~/common/api/naluri';
import {
  FEEDS_GET_FEEDS_BEGIN,
  FEEDS_GET_FEEDS_SUCCESS,
  FEEDS_GET_FEEDS_FAILURE,
  FEEDS_GET_FEEDS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getFeeds(userID = '', initial = 1) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: FEEDS_GET_FEEDS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { feeds } = getState();
      const page = initial ? initial : feeds.pagination ? feeds.pagination.page + 1 : 1;

      const doRequest = Naluri.get(`/api/expert/feed_history?user_id=${userID}&page=${page}`);
      doRequest.then(
        res => {
          dispatch({
            type: FEEDS_GET_FEEDS_SUCCESS,
            data: res.data,
            pagination: res.pagination,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: FEEDS_GET_FEEDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFeedsError() {
  return {
    type: FEEDS_GET_FEEDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_GET_FEEDS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFeedsPending: true,
        getFeedsError: null,
      };

    case FEEDS_GET_FEEDS_SUCCESS:
      // The request is success

      return {
        ...state,
        news: state.news.withMutations(news =>
          action.data.map(d => {
            let isExist = news.find(n => n.id === d.id);
            return !isExist ? news.push(d) : null;
          }),
        ),
        pagination: action.pagination,
        getFeedsPending: false,
        getFeedsError: null,
      };

    case FEEDS_GET_FEEDS_FAILURE:
      // The request is failed
      return {
        ...state,
        getFeedsPending: false,
        getFeedsError: action.data.error,
      };

    case FEEDS_GET_FEEDS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFeedsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/getFeeds.js